module.exports = __webpack_public_path__ + "assets/img/google-play.d6560d1d.png";